module.exports = __webpack_public_path__ + "static/header1-c2720135894f17088d6ddaec67aa87b3.png";